import React from 'react';
import * as S from 'view/atoms/TextArea/TextArea.styles'; // Reusing StyledUrlSpan
import { URL_FIND_REGEX } from 'utils/regExp';

type RenderUrlOptions = {
  asLink?: boolean;
  linkProps?: React.AnchorHTMLAttributes<HTMLAnchorElement>;
};

export const formatTextWithUrls = (
  text: string,
  options?: RenderUrlOptions,
): React.ReactNode[] => {
  if (!text) return [];

  const { asLink = false, linkProps = {} } = options || {};
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;

  text.replace(URL_FIND_REGEX, (match, url, offset) => {
    if (offset > lastIndex) {
      // Push the text before the URL match
      parts.push(text.substring(lastIndex, offset));
    }

    if (asLink) {
      // Render the URL as a link
      parts.push(
        <S.StyledUrlSpan
          as='a'
          href={url}
          key={url + offset}
          target='_blank'
          rel='noopener noreferrer'
          {...linkProps}
        >
          {url}
        </S.StyledUrlSpan>,
      );
    } else {
      // Render the URL as a styled span
      parts.push(<S.StyledUrlSpan key={url + offset}>{url}</S.StyledUrlSpan>);
    }

    lastIndex = offset + match.length; // Update lastIndex to the end of the current match
    return '';
  });

  // Push any remaining text after the last URL match
  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }

  return parts;
};
